import { ImportIcon } from "evergreen-ui";
import React, { useRef, useState } from "react";

interface IProps {
  handleFiles: any;
  selectedFiles: any;
}
const DragZone: React.FC<IProps> = ({ handleFiles, selectedFiles }) => {
  const fileInputRef = useRef<any>();
  const [error, setError] = useState("");

  const filesSelected = (e) => {
    let files = e.target.files;
    if (files.length + selectedFiles.length > 10) {
      return setError("Maximum 10 files each upload is allowed.");
    } else {
      setError("");
    }
    handleFiles(Array.from(files));
  };

  const fileInputClicked = () => {
    fileInputRef.current.click();
  };
  const dragOver = (e) => {
    e.preventDefault();
  };

  const dragEnter = (e) => {
    e.preventDefault();
  };

  const dragLeave = (e) => {
    e.preventDefault();
  };

  const fileDrop = (e) => {
    e.preventDefault();
    const files = e.dataTransfer.files;
    if (files.length + selectedFiles.length > 10) {
      return setError("Maximum 10 files each upload is allowed.");
    } else {
      setError("");
    }
    handleFiles(Array.from(files));
  };
  return (
    <>
      {Boolean(error) && (
        <p className=" text-red-500 text-sm text-center mb-2">{error}</p>
      )}
      <div
        onDragOver={dragOver}
        onDragEnter={dragEnter}
        onDragLeave={dragLeave}
        onDrop={fileDrop}
        onClick={fileInputClicked}
        className=" hover:border-blue-500 cursor-pointer w-full bg-blue-50 border-dashed p-4 border-blue-300 border-4 flex flex-col items-center justify-center"
      >
        <input
          multiple
          ref={fileInputRef}
          type="file"
          className=" h-0 w-0 opacity-0"
          onChange={filesSelected}
        />
        <ImportIcon size={28} className=" text-blue-300 mb-3" />
        Drag files or click here to start uploading!
      </div>
    </>
  );
};

export default DragZone;
